/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

import OrientationEnum from '../../orientation/orientation-enum';
import LoaderRoot from '../../loader/loader-root';
import template from './viewer-root.html';

// TODO #295 Přesunout loading mimo tuto třídu.
// - Ideálně do něčeho jako LoaderService,
//   která bude napojená na loader vygenerovaní v `index.html`.
//   HTML kód loading by měl zůstat zachován bez zbytečného odebírání z DOM.
//   Díky tomu by do budoucna nebylo nutné řešit čekání na `rootVisible`.
// - Zatím je použitý hotfix s přepínáním mezi dvěma elementy `viewer-root`.
//   Při použití samostatného `v-if` bez `v-else` se vkládá rušivý komentář.
//   Na pozadí stejně Vue `viewer-root` element recykluje,
//   takže se při přepnutí zachová.
// TODO Přidat UML diagram s posloupností spouštění prolínače (orientace, obsah, loading).
export default {
  name: 'ViewerRoot',
  template,
  components: { LoaderRoot },
  computed: {
    className() {
      const { orientationEnum } = this;
      switch (orientationEnum) {
        case OrientationEnum.CLOCKWISE_0:
          return 'viewer-root--orientation-0';
        case OrientationEnum.CLOCKWISE_90:
          return 'viewer-root--orientation-90';
        case OrientationEnum.CLOCKWISE_180:
          return 'viewer-root--orientation-180';
        case OrientationEnum.CLOCKWISE_270:
          return 'viewer-root--orientation-270';
        default:
          return '';
      }
    },
    loaderVisible() {
      // Musí být známa orientace,
      // aby se mohli určit rozměry do kterých se bude vykreslovat.
      return this.orientationEnum;
    },
    rootVisible() {
      // Dokud není doručen nějaký obsah,
      // tak se zobrazuje loading animace.
      return this.contentReady && this.orientationEnum;
    }
  },
  created() {
    const { device } = this.$root;
    // Naslouchání událostem.
    device.on('content', this.onContent);
    // Aktualizace orientace zařízení.
    this.refresh();
    // Spuštění synchronizace.
    device.connect().catch((error) => this.handleError(error));
  },
  data() {
    return {
      contentReady: !isNil(this.$root.session.contentTimestamp),
      orientationEnum: null
    };
  },
  destroyed() {
    const { device } = this.$root;
    // Zrušení naslouchání událostem.
    device.off('content', this.onContent);
    const { director } = this;
    if (!isNil(director)) {
      this.destroyDirector(director);
    }
  },
  methods: {
    createDirector() {
      const director = this.$root.device.createDirector(this.$el);
      director.on('error', this.onError);
      director.on('entered', this.onEntered);
      director.on('played', this.onPlayed);
      return director;
    },
    destroyDirector(director) {
      director.off('error', this.onError);
      director.off('entered', this.onEntered);
      director.off('played', this.onPlayed);
      this.$root.device.destroyDirector(director);
    },
    handleError(error) {
      this.$emit('error', error);
    },
    onContent() {
      this.contentReady = true;
      // Aktualizace orientace zařízení.
      // TODO Logičtější by asi bylo, aby reagovalo na změnu orientace a ne obsahu.
      this.refresh();
    },
    onEntered(scheduleInfo) {
      this.$emit('entered', scheduleInfo);
    },
    onError(error) {
      this.handleError(error);
    },
    onPlayed(scheduleInfo) {
      this.$root.device
        .hit(scheduleInfo)
        .catch((error) => this.handleError(error));
    },
    refresh() {
      this.$root.screenManager
        .getCssOrientation()
        .then((orientationEnum) => {
          this.orientationEnum = orientationEnum;
        })
        .catch((error) => this.handleError(error));
    }
  },
  watch: {
    // TODO #295 Hotfix spuštění prolínače.
    // - Technický dluh z předchozí implementace se zanořením do ViewerList.
    // - Spoléhá se, že již prolínač nebude deaktivován,
    //   že se nebude vytvářet opakovaně apod.
    // - Ideálně by se komponenta neměla zobrazovat,
    //   dokud nebudou přebné informace dostupné (orientace, obsah, ...).
    rootVisible(value) {
      if (!value || this.director) {
        // Dokud nejsou informace dostupné, nic se nedělá.
        // Opakovaná volání jsou také ignorována.
        return;
      }
      // Počká se na vykreslení elementu a zahájí se zobrazování prolínače.
      // Vue nedovoluje pokročilou správu elementů,
      // takže nelze pro implmentaci prolínače použít.
      this.$nextTick(() => {
        const director = this.createDirector();
        this.director = director;
      });
    }
  }
};
